// removed by extract-text-webpack-plugin
module.exports = {"tiny":"380px","mobile":"768px","medium":"769px","large":"1013px"};


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/directory/GridDirectoryComponent.scss
// module id = 1214
// module chunks = 0